import React from "react";

import * as S from "./styles";

import IProps from "./props";

const Analizing: React.FC<IProps> = ({ handleClick }) => (
  <S.Container>
    <S.Title>
      Parabéns, o seu cadastro foi <br /> finalizado com sucesso!
    </S.Title>
    <S.Text>
      Em breve você receberá um e-mail com os dados para
      <br />
      pagamento e envio de documentação. Após esses passos o
      <br />
      seu login será liberado para que você desfrute de todos os
      <br />
      nossos benefícios!
    </S.Text>
    <S.Button onClick={handleClick} type="button">
      Clique aqui para Sair e aguarde até sua análise sejá feita!
    </S.Button>
  </S.Container>
);

export default Analizing;
